import React from 'react';

class WorkVisualsPager extends React.Component {
    constructor(props) {
        super(props);

        this.usesTwoColumns = this.props.assets.length > 4;
        this.pagerItemsCountLimit = Math.floor(this.props.assets.length / 2);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(this.props.activeIndex !== nextProps.activeIndex) {
            return true;
        }
        
        return false;
    }

    renderPager() {
        let pagerItems = '';

        if(this.usesTwoColumns) {
            let leftIndex = 1;
            let rightIndex = 2;
            let pagerItemIndex = 1;

            pagerItems = this.props.assets.map((asset, index) => {
                if(index === 0) {
                    pagerItemIndex = 1;
                }
                else if(index < this.pagerItemsCountLimit && index > 0) {
                    leftIndex += 2;
                    pagerItemIndex = leftIndex;
                }
                else if(index === this.pagerItemsCountLimit) {
                    pagerItemIndex = 2;
                }
                else if(index > this.pagerItemsCountLimit) {
                    rightIndex += 2;
                    pagerItemIndex = rightIndex;
                }

                return <li className={(index === this.pagerItemsCountLimit) ? 'reset' : ''} key={index} style={{order: pagerItemIndex}}>{this.renderPagerItemLink(index)}</li>;
            });
        }
        else {
            pagerItems = this.props.assets.map((asset, index) => {
                return <li key={index}>{this.renderPagerItemLink(index)}</li>;
            });
        }

        return <ul className={`work-pager first no-style ${(this.usesTwoColumns) ? 'dual-columns' : 'single-column'}`}>{pagerItems}</ul>;
    }

    renderPagerItemLink(index) {
        return <a className={`red ${this.props.activeIndex === index ? 'active' : ''}`} onClick={this.props.onClickCallback} data-index={index} href="">{((index + 1 < 10) ? `0${index + 1}` : index + 1)}.</a>;
    }

    render() {
        return (
            <div className={`work-visuals-pager ${(this.props.alignment === 'middle') ? 'abs' : ''}`}>{this.renderPager()}</div> 
        );
    }
};

export default WorkVisualsPager;


// WEBPACK FOOTER //
// ./src/components/WorkVisualsPager.js